import React, {FC} from 'react';
import Button from 'components/Button';
import {Variant} from 'components/Button/variants';

import {useConfig} from './useConfig';

export type OmniButtonProps = {
	actionBtnConfig: string;
	actionBtnText?: string;
	variant: Variant;
	className?: string;
}

export const OmniButton: FC<OmniButtonProps> = ({
	actionBtnConfig,
	actionBtnText,
	variant,
	className,
}) => {
	const result = useConfig(actionBtnConfig);
	return(
		<>
			<Button variant={variant} onClick={result.onClick} className={className}>
				{actionBtnText}
			</Button>
			{result.render}
		</>
	);
};

export default OmniButton;
